import React, { Component } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import * as actions from '../../../actions'
import { connect } from 'react-redux'

class PreIngresoCalado2 extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.cancelarPreingreso = this.cancelarPreingreso.bind(this)
  }

  componentDidMount () {
    const { cpa, fotoCea } = this.props
    this.props.getFoto(cpa.ctg)
    this.intervalFotoCea = setInterval(() => {
      if (!fotoCea && fotoCea.fotoPreingresoCalado) {
        this.props.detenerConsultaFoto()
      } else {
        this.props.getFoto(cpa.ctg)
      }
    }, 1000)
  }

  componentWillUnmount () {
    clearInterval(this.intervalFotoCea)
  }

  handleSubmit (e) {
    e.preventDefault()
    const {
      cpa,
      submitPreIngreso
    } = this.props
    submitPreIngreso(cpa.ctg)
  }

  cancelarPreingreso () {
    const { fotoCea, cpa } = this.props
    if (fotoCea && fotoCea.numeroctge && cpa) {
      const fecha = fotoCea.fechaDeIngreso
      this.props.deleteFoto(fecha)
    }
    this.props.cancelPreIngreso()
  }

  render () {
    const {
      cpa,
      fotoCea
    } = this.props

    let foto
    if (fotoCea && fotoCea.foto) {
      foto = fotoCea.foto
    }

    console.log('foto', foto)
    return (
      <div style={{ overflow: 'hidden' }} >
        <Col>
          <h2 style={{ textAlign: 'center', margin: '2% 0' }}>Confirme si los datos son correctos</h2>
        </Col>
        <Card className='shadow bg-white rounded card-confirmacion-preingreso'>
          <form>
            <Card.Body className='body-confirmacion-preingreso'>
              <div className='confirmacion-preingreso-datos'>
                {/* <div>
                  <Card.Title className='texto-confirmacion-preingreso' >Número de CTG</Card.Title>
                  <h1 className='confirmacion-preingreso-dato'>{cpa.ctg}</h1>
                </div> */}
                <Row>
                  <Col md={6}>
                    <Card.Title className='texto-confirmacion-preingreso' >Patente</Card.Title>
                    <h1 className='confirmacion-preingreso-dato'>{cpa.camion}</h1>
                  </Col>
                  <Col md={6}>
                    <Card.Title className='texto-confirmacion-preingreso' >Cereal</Card.Title>
                    <h1 className='confirmacion-preingreso-dato'>{cpa.cereal}</h1>
                  </Col>
                </Row>

                <Col md={12}>
                  <Card.Title className='texto-confirmacion-preingreso' >Chofer</Card.Title>
                  <h1 className='confirmacion-preingreso-dato'>{cpa.chofer}</h1>
                </Col>

              </div>
              <div className='confirmacion-preingreso-foto'>
                {foto && <img src={foto} alt='Foto preingreso calado' /> }
                {(!foto) && <div>
                  <div style={{ margin: '0 auto' }} className='loader' />
                </div>}
              </div>
            </Card.Body>

            <Button
              variant='contained'
              className='btn-preingreso'
              style={{ margin: '8px' }}
              onClick={this.cancelarPreingreso}
              size='large'
              color='primary'
            >
              Cancelar
            </Button>

            <Button
              variant='contained'
              style={{ margin: '8px' }}
              className='btn-preingreso'
              onClick={this.handleSubmit}
              size='large'
              color='primary'
            >
              Confirmar
            </Button>

          </form>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    cpa: state.camionesIngreso.consultaCpa,
    callePreIngreso: state.calado.callePreIngreso,
    fotoCea: state.calado.fotoCea
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(PreIngresoCalado2)
